<section class="mt-5">
  <h2 class="h4">User List</h2>
  <ng-container *ngIf="adminService.usersList$ | async as allUsers">
    <p-table #dt [columns]="cols" [value]="allUsers" [lazy]="true" (onLazyLoad)="adminService.loadUsersList($event)" [paginator]="true" [alwaysShowPaginator]="false" [rows]="rows" [totalRecords]="totalRecords" [autoLayout]="true" responsiveLayout="scroll" [exportFilename]="exportFilename" [loading]="adminService.loadingUsersList">
      <ng-template pTemplate="caption" *removeIfUnauthorized="['Application Administrator', 'NESS Administrator']">
        <div class="p-2">
          <button type="button" class="btn btn-active" (click)="exportUserList(null)">Export to CSV</button>
        </div>
      </ng-template>
      <ng-template pTemplate="header" let-columns>
        <tr>
          <ng-container *ngFor="let col of columns">
            <th scope="col" class="border-bottom-0" *ngIf="col.field !== 'UserType' && col.field !== 'LastLoginTimestamp' && col.field !== 'FieldDivisionName' && col.field !== 'FieldDivisionGroup'" [pSortableColumn]="col.field">
              {{col.header}}
              <p-sortIcon [field]="col.field" ariaLabel="Activate to sort" ariaLabelDesc="Activate to sort in descending order" ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
            </th>
            <ng-container *ngIf="col.field === 'FieldDivisionName' || col.field === 'FieldDivisionGroup'">
              <th scope="col" class="border-bottom-0" *removeIfUnauthorized="['NESS Administrator']" [pSortableColumn]="col.field">
                {{col.header}}
                <p-sortIcon [field]="col.field" ariaLabel="Activate to sort" ariaLabelDesc="Activate to sort in descending order" ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
              </th>
            </ng-container>
            <th scope="col" class="border-bottom-0" *ngIf="col.field === 'UserType'" [pSortableColumn]="'UserType.UserTypeDsiaplyName'">
              {{col.header}}
              <p-sortIcon [field]="'UserType.UserTypeDsiaplyName'" ariaLabel="Activate to sort" ariaLabelDesc="Activate to sort in descending order" ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
            </th>
            <th scope="col" class="border-bottom-0" *ngIf="col.field === 'LastLoginTimestamp'" [pSortableColumn]="'LastLoginTimestamp'">
              {{col.header}}
              <p-sortIcon [field]="'LastLoginTimestamp'" ariaLabel="Activate to sort" ariaLabelDesc="Activate to sort in descending order" ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
            </th>
          </ng-container>
        </tr>
        <tr>
          <ng-container *ngFor="let col of columns">
            <th scope="col">
              <ng-container *ngIf="col.field == 'FirstName' || col.field == 'LastName' || col.field == 'Email'">
                <label class="visually-hidden" for="filterBy{{col.field}}">Filter by {{col.header}} column</label>
                <input id="filterBy{{col.field}}" class="form-control form-control-sm" type="text" (input)="dt.filter($event.target['value'], col.field, col.filterMatchMode)">
              </ng-container>
              <ng-container *ngIf="col.field == 'SSN'">
                <label class="visually-hidden" for="filterBy{{col.field}}">Filter by {{col.header}} column</label>
                <input id="filterBy{{col.field}}" class="form-control form-control-sm" type="text" (input)="dt.filter($event.target['value'], col.field, col.filterMatchMode)" maxlength="11">
              </ng-container>
              <span *ngIf="col.field == 'PhoneNumber' || col.field == 'Agency' || col.field == 'UserType'|| col.field == 'ConcatenatedRoles'|| col.field == 'Disabled'|| col.field == 'RecertificationYear'|| col.field == 'LastLoginTimestamp'" class="visually-hidden">(No filter available for {{col.field}} column)</span>
            </th>
          </ng-container>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-rowData let-columns="columns">
        <tr>
          <ng-container *ngFor="let col of columns">
            <td [ngSwitch]="col.field">
              <ng-container *ngSwitchCase="'PhoneNumber'">{{ rowData.PhoneNumber | phoneNumberFormat }}</ng-container>
              <ng-container *ngSwitchCase="'LastLoginTimestamp'">{{ rowData.LastLoginTimestamp | date:'MM/dd/yyyy' }}</ng-container>
              <ng-container *ngSwitchCase="'LastName'">
                <button *ngIf="canUpdateUsers && currentUser.Email !== rowData.Email; else defaultLastName" [attr.aria-label]="'User '+rowData.UserName+'  details'" class="btn btn-link text-nowrap" (click)="viewUserDetails(rowData)">{{ rowData.LastName }}</button>
                <ng-template #defaultLastName>{{ rowData.LastName }}</ng-template>
              </ng-container>
              <ng-container *ngSwitchCase="'FieldDivisionName'"><ng-container *removeIfUnauthorized="['NESS Administrator']">{{ rowData.FieldDivisionName }}</ng-container></ng-container>
              <ng-container *ngSwitchCase="'FieldDivisionGroup'"><ng-container *removeIfUnauthorized="['NESS Administrator']">{{ rowData.FieldDivisionGroup }}</ng-container></ng-container>
              <ng-container *ngSwitchDefault>{{rowData[col.field]}}</ng-container>
            </td>
          </ng-container>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage" let-columns>
        <tr>
          <td [attr.colspan]="columns.length">
            No users found.
          </td>
        </tr>
      </ng-template>
    </p-table>
  </ng-container>
</section>
<p-sidebar (onShow)="onShowSidebar()" [(visible)]="showSidebar" position="right" [blockScroll]="true" styleClass="p-sidebar-lg" [showCloseIcon]="false" (onHide)="onHideSidebar()">
  <ng-container *ngIf="showUserInfoDetailView">
    <ness-userinformation (onChange)="onChange.emit($event)" [userInfoForOtherUser]="userInfoForOtherUser$ | async" [ownProfile]="false" (userUpdated)="userUpdated($event)"></ness-userinformation>
    <div class="mx-3">
      <ness-user-history [userHistory]="userHistory$ | async"></ness-user-history>
      <button type="button" (click)="onHideSidebar()" class="btn btn-active my-3">Close</button>
    </div>
  </ng-container>
</p-sidebar>
